import {useMutation} from '@tanstack/react-query';
import {ShipmentMessage} from '@shipwell/backend-core-sdk';
import {createShipmentMessage} from './typed';

export const useCreateShipmentMessage = (shipmentId: string) => {
  return useMutation((message: ShipmentMessage) => createShipmentMessage(shipmentId, message));
};
